const QUICK_FIND_HISTORY_LABELS = {
  eat: "Food nearby",
  drink: "Drinks nearby",
  fun: "Fun nearby",
};

function normalizeQuickFindCategoryKey(value = "") {
  const key = String(value || "").trim().toLowerCase();
  return QUICK_FIND_HISTORY_LABELS[key] ? key : "";
}

function cleanId(value = "") {
  return String(value || "").trim();
}

function uniqueIds(values = []) {
  return Array.from(
    new Set(
      (Array.isArray(values) ? values : [])
        .map(cleanId)
        .filter(Boolean)
    )
  );
}

export function getQuickFindHistoryPrompt(categoryKey = "") {
  return QUICK_FIND_HISTORY_LABELS[normalizeQuickFindCategoryKey(categoryKey)] || "Find";
}

export function buildQuickFindHistoryRecord({
  categoryKey = "",
  center = null,
  placeId = "",
  locationLabel = "",
  markers = [],
  capsules = [],
} = {}) {
  const quickFindCategoryKey = normalizeQuickFindCategoryKey(categoryKey);
  if (!quickFindCategoryKey) return null;

  const markerIds = (Array.isArray(markers) ? markers : []).map((marker) => marker?.id || marker?.capsuleId);
  const capsuleIdsFromCapsules = (Array.isArray(capsules) ? capsules : []).map((capsule) => capsule?.id || capsule?.capsuleId);
  const normalizedMarkerIds = uniqueIds(markerIds);
  const capsuleIds = normalizedMarkerIds.length ? normalizedMarkerIds : uniqueIds(capsuleIdsFromCapsules);
  if (!capsuleIds.length) return null;

  const idSet = new Set(capsuleIds);
  const recordCapsules = (Array.isArray(capsules) ? capsules : [])
    .filter((capsule) => idSet.has(cleanId(capsule?.id || capsule?.capsuleId)))
    .map((capsule) => ({
      ...capsule,
      id: cleanId(capsule?.id || capsule?.capsuleId),
    }));

  return {
    prompt: getQuickFindHistoryPrompt(quickFindCategoryKey),
    capsuleIds,
    capsules: recordCapsules,
    center,
    placeId: String(placeId || "").trim(),
    locationLabel: String(locationLabel || "").trim(),
    quickFindCategoryKey,
    source: "quick_find",
  };
}
